import { render, staticRenderFns } from "./pc_index.vue?vue&type=template&id=9b6c6cce&scoped=true"
import script from "./pc_index.vue?vue&type=script&lang=js"
export * from "./pc_index.vue?vue&type=script&lang=js"
import style0 from "./pc_index.vue?vue&type=style&index=0&id=9b6c6cce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6c6cce",
  null
  
)

export default component.exports